import React, { useState } from "react";

const API_BASE_URL = "/api";

function AdminForgotPasswordModal({ onClose }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    if (!email.trim()) {
      setError("لطفاً ایمیل حساب مدیریتی خود را وارد کنید.");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${API_BASE_URL}/staff/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email.trim(),
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        setError(data.message || "خطا در ارسال لینک بازیابی رمز عبور.");
        return;
      }

      setMessage(data.message || "لینک بازیابی رمز عبور به ایمیل ارسال شد.");
      setEmail("");
    } catch (err) {
      console.error("Forgot password request error:", err);
      setError("ارتباط با سرور برقرار نشد.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="admin-forgot-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="بازیابی رمز عبور"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="admin-forgot-modal">
        <button
          type="button"
          className="admin-forgot-close"
          onClick={onClose}
          aria-label="بستن"
        >
          ×
        </button>

        <div className="admin-forgot-icon">🔐</div>

        <h2>بازیابی رمز عبور</h2>

        <p>
          ایمیل حساب مدیریتی خود را وارد کنید تا لینک تغییر رمز عبور برای شما
          ارسال شود.
        </p>

        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label>ایمیل پنل مدیریت</label>
            <input
              type="email"
              placeholder="مثلاً iem.ictgroup@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              dir="ltr"
            />
          </div>

          <button type="submit" className="auth-submit-btn" disabled={loading}>
            {loading ? "در حال ارسال..." : "ارسال لینک بازیابی رمز عبور"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminForgotPasswordModal;
